import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface CopySourceOption {
    code: string;
    name: string;
}

export interface CreatePricingProfileDialogData {
    existingProfiles: CopySourceOption[];
    suggestedCode?: string;
    suggestedName?: string;
}

export interface CreatePricingProfileDialogResult {
    code: string;
    name: string;
    description: string;
    copyFromProfileCode: string | null;
}

@Component({
    selector: 'app-create-pricing-profile-dialog',
    templateUrl: './create-pricing-profile-dialog.component.html',
    styleUrls: ['./create-pricing-profile-dialog.component.scss']
})
export class CreatePricingProfileDialogComponent {
    form: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<CreatePricingProfileDialogComponent, CreatePricingProfileDialogResult>,
        @Inject(MAT_DIALOG_DATA) public data: CreatePricingProfileDialogData,
        private fb: FormBuilder
    ) {
        this.form = this.fb.group({
            code: [data.suggestedCode ?? '', [Validators.required, Validators.maxLength(8)]],
            name: [data.suggestedName ?? '', [Validators.required, Validators.maxLength(60)]],
            description: ['', [Validators.required, Validators.maxLength(180)]],
            copyFromProfileCode: ['']
        });
    }

    get isManualEntry(): boolean {
        return !this.form.get('copyFromProfileCode')?.value;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onCreate(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        const raw = this.form.getRawValue();
        this.dialogRef.close({
            code: String(raw.code).trim().toUpperCase(),
            name: String(raw.name).trim(),
            description: String(raw.description).trim(),
            copyFromProfileCode: raw.copyFromProfileCode ? String(raw.copyFromProfileCode) : null
        });
    }
}
